import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  MutationCastVoteArgs,
  Poll,
} from '@tribeplatform/gql-client/types'
import type { PollFields } from '@tribeplatform/gql-client/types/generated'

import { useQueryClient } from '../../lib/index.js'
import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getPollKey } from '../../utils/keys/index.js'

export const useCastVote = (options?: {
  fields?: PollFields
  useMutationOptions?: UseMutationOptions<
    Poll,
    ClientError,
    MutationCastVoteArgs
  >
}) => {
  const queryClient = useQueryClient()
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const { onSuccess, ...restUseMutationOptions } = useMutationOptions || {}

  return useMutation<Poll, ClientError, MutationCastVoteArgs>(
    (input: MutationCastVoteArgs) => client.polls.castVote(input, fields),
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueryData(getPollKey(data.id), data)

        onSuccess?.(data, variables, context)
      },
      ...restUseMutationOptions,
    },
  )
}
